import { FilterIcon } from "@heroicons/react/outline";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "~/design-system/Button";
import { DialogTrigger } from "~/design-system/Dialog";
import type { Filters } from "../../UserNotificationsScreen";
import { NotificationsFilterDialog } from "../NotificationsContent/components/components/NotificationsFilter/NotificationsFilterDialog";

type FilterNotificationsButtonProps = {
  setFilters: React.Dispatch<React.SetStateAction<Filters>>;
  filters: Filters;
};

function FilterNotificationsButton(props: FilterNotificationsButtonProps) {
  const { t } = useTranslation();

  return (
    <NotificationsFilterDialog
      filters={props.filters}
      setFilters={props.setFilters}
    >
      <DialogTrigger asChild>
        <Button
          dataClovisActionId="user-notifications-filter"
          variant="soft"
          color="brandAccent"
          opacity="light"
          circular
          iconLabel={t(
            "screens.UserNotificationsScreen.UserNotificationsScreenActions.filter",
            "Filter"
          )}
        >
          <FilterIcon />
        </Button>
      </DialogTrigger>
    </NotificationsFilterDialog>
  );
}

export { FilterNotificationsButton };
